<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";
import Calendar from "primevue/calendar";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Stat,
    Calendar
  },
  data() {
    return {
      // O seletor de mês era o `vue-monthly-picker`, um pacote que NUNCA
      // esteve no package.json nem no node_modules — o import quebrava o build
      // e por isso a rota /acessa/graduacao nunca chegou a ser registrada.
      // Trocado pelo Calendar do PrimeVue, o mesmo componente usado por todas
      // as outras telas do Acessa (leads, clientes, adesão, recorrente), sem
      // nenhuma dependência nova.
      periodMonth: new Date(),

      table: {
        body: null,
        loading: true,
        errored: false,
      },

      statData: null,
    };
  },
  methods: {
    // A API espera `YYYY-MM` (com o mês em dois dígitos), formato que o moment
    // produzia antes.
    getPeriod() {
      const date = this.periodMonth ? new Date(this.periodMonth) : new Date();
      const month = String(date.getMonth() + 1).padStart(2, "0");

      return date.getFullYear() + "-" + month;
    },
    // Três estados distintos, e não dois: carregando, erro e vazio. Antes o
    // "carregando" era inferido de `table.body === null`, então uma resposta
    // com `status != 'success'` deixava o spinner girando para sempre, e um
    // erro de rede virava "nenhum registro encontrado".
    getGraduation() {
      this.table.body = null
      this.table.loading = true
      this.table.errored = false

      api
        .get('acessa/graduacao?date=' + this.getPeriod())
        .then(response => {
          if (response.data.status == 'success') {
            this.statData = [
              {
                type: "line",
                icon: "bxs-graduation",
                title: "Graduação",
                value: response.data.current.name,
              },
              {
                type: "line",
                icon: "bx-user",
                title: "Assinaturas",
                value: this.$options.filters.points(response.data.graduation.clients.actives)
              },
              {
                type: "line",
                icon: "bx-bar-chart-square",
                title: "Meta do Mês",
                value: this.$options.filters.points(response.data.graduation.clients.monthly)
              },
            ]

            this.table.body = response.data.list || []
          } else {
            this.statData = [
              {
                type: "line",
                icon: "bxs-graduation",
                title: "Graduação",
                value: "-",
              },
            ]

            // Sem este [] o spinner ficava girando indefinidamente.
            this.table.body = []
          }
        })
        .catch(() => {
          this.table.errored = true
          this.table.body = []
          // Sem isto os cards de topo continuariam mostrando os números do mês
          // anterior logo acima da mensagem de erro do mês novo.
          this.statData = null
        })
        .finally(() => {
          this.table.loading = false
        })
    }
  },
  mounted() {
    this.getGraduation()
  },
  watch: {
    periodMonth: function () {
      this.getGraduation()
    }
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Acessa</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Graduação</h3>
        <p></p>
      </div>
      <!-- O input do Calendar não tem rótulo visível; sem o aria-label ele é
           anunciado só como "caixa de texto". -->
      <Calendar
        v-model="periodMonth"
        view="month"
        dateFormat="mm/yy"
        aria-label="Mês de referência"
      />
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-6 col-xl-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" :image="stat.image" />
      </div>
    </div>

    <div v-if="table.loading" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
        <span class="sr-only">Carregando graduação</span>
      </div>
    </div>

    <div v-else-if="table.errored" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-frown font-size-24"></i><br>
          Não foi possível carregar a graduação deste mês.<br>
          <b-button variant="default" size="sm" class="mt-2" @click="getGraduation">
            Tentar novamente
          </b-button>
        </div>
      </div>
    </div>

    <div v-else-if="!table.body || table.body.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum registro encontrado
        </div>
      </div>
    </div>

    <div v-else class="row">
      <div v-for="(td, index) in table.body" :key="index" class="col-xl-3 col-md-6">
        <div class="card" :class="td.status">
          <div class="card-body d-flex align-items-center py-2 px-3">
            <div v-if="td.status == 'graduated'" class="graduation-bookmark">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                <path d="M19 10.132v-6c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2V22l7-4.666L19 22V10.132z"></path>
              </svg>
            </div>
            <div class="graduation-icon">
              <img v-if="td.image" :src="require('@/assets/images/graduations/' + td.image)" />
              <img v-else src="@/assets/images/logo-icon.png" class="" />
            </div>
            <div class="ml-3">
              <h6 class="mb-0 font-weight-normal">{{ td.name }}</h6>
              <h4 class="mb-0">{{ td.clients.actives | points }} <small class="font-size-14">assinaturas</small></h4>
              <h6 class="mb-0">{{ td.clients.monthly | points }} <small class="font-size-14">meta do mês</small></h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.graduation-bookmark {
  position: absolute;
  top: -7px;
  right: 0;
}
.graduation-icon img {
  background: #CED4DB;
  border-radius: 100%;
  width: 80px;
  height: 80px;
}
.ungraduated {
  opacity: 0.5;
}
</style>